module.exports = __webpack_public_path__ + "static/media/jarvis-icon.c1873824.svg";